var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 16.1703L5.52989 12.7003C5.13989 12.3103 4.50989 12.3103 4.11989 12.7003C3.72989 13.0903 3.72989 13.7203 4.11989 14.1103L8.29989 18.2903C8.68989 18.6803 9.31989 18.6803 9.70989 18.2903L20.2899 7.71031C20.6799 7.32031 20.6799 6.69031 20.2899 6.30031C19.8999 5.91031 19.2699 5.91031 18.8799 6.30031L8.99989 16.1703Z",
    fill: "white",
    fillOpacity: 0.82
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e57021961bb86ed61125f042e27aa9da.svg";
export { ForwardRef as ReactComponent };